import { FC } from 'react';
import { Spin, SpinProps } from 'antd';

type LoadingProps = SpinProps & {
  containerClassName?: string;
  style?: React.CSSProperties;
};

const Loading: FC<LoadingProps> = ({
  containerClassName = '',
  tip = '',
  style,
}) => {
  return (
    <div
      className={`h-[200px] flex justify-center items-center ${containerClassName}`}
      style={style}
    >
      <Spin />
    </div>
  );
};

export default Loading;
